import LoadingSpinner from "@/components/LoadingSpinner";
import { useAuth0Callback } from "@/queries/auth/useAuth0Callback";
import { displayErrorToast } from "@/utils/toast";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export const AuthenticatePage = () => {
  const { isAuthenticated, error, isLoading, getAccessTokenSilently } =
    useAuth0();

  const { createUser } = useAuth0Callback();

  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [tokenError, setTokenError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      getAccessTokenSilently({
        authorizationParams: {
          audience: `https://${import.meta.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`,
          scope: "openid profile email",
        },
      })
        .then((token) => {
          setAccessToken(token);
        })
        .catch((err) => {
          setTokenError(err?.message || "Failed to get access token");
        });
    }
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  useEffect(() => {
    if (isAuthenticated && !isLoading && accessToken) {
      createUser(accessToken);
    }
  }, [isAuthenticated, isLoading, createUser, accessToken]);

  if ((!isAuthenticated && !isLoading) || tokenError) {
    displayErrorToast(error?.message || tokenError || "Something went wrong");
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex min-h-[500px] items-center justify-center">
      <div className="w-full max-w-md rounded-3xl bg-white p-12 text-center">
        <span className="mb-4 text-xl font-bold leading-tight text-gray-900">
          Welcome to PromptLayer!
        </span>
        <p className="mt-2 text-lg text-gray-600">Logging in..</p>
        <div className="mt-4 flex items-center justify-center">
          <LoadingSpinner />
        </div>
      </div>
    </div>
  );
};
